// // import React from "react";
// // import { Link } from "react-router-dom";
// // import "../home.css"; // same css file will handle navbar styling

// // export default function MainNavbar() {
// //   return (
// //     <nav className="navbar nav-menu">
// //       <Link to="/" className="nav-link nav-item active">Home</Link>
// //          <Link className="nav-link nav-item">About Us</Link>
// //           <Link className="nav-link nav-item">Careers</Link>
// //       <Link to="/programs" className="nav-link nav-item">Programs</Link>
// //       {/* <Link className="nav-link nav-item">Internships</Link> */}
// //       <Link className="nav-link nav-item">Contact</Link>
// //     </nav>
// //   );
// // }

// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import "../home.css";

// export default function MainNavbar() {
//   const [menuOpen, setMenuOpen] = useState(false);

//   return (
//     <>
//       <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
//         <i className="fas fa-bars"></i>
//       </div>
//       <nav className={`navbar nav-menu ${menuOpen ? "show-menu" : ""}`}>
//         <Link to="/" className="nav-link nav-item active">Home</Link>
//         <Link to="/about-us" className="nav-link nav-item">About Us</Link>
//         <Link to="/carrers" className="nav-link nav-item">Careers</Link>
//         <Link to="/programs" className="nav-link nav-item">Programs</Link>
//         <Link to="/contact-us" className="nav-link nav-item">Contact</Link>

//       </nav>
//     </>
//   );
// }

import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../home.css";

export default function MainNavbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleLinkClick = () => {
    setMenuOpen(false);
  };

  return (
    <>
      <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
        <i className="fas fa-bars"></i>
      </div>
      <nav className={`navbar nav-menu ${menuOpen ? "show-menu" : ""}`}>
        <Link
          to="/"
          className="nav-link nav-item active"
          onClick={handleLinkClick}
        >
          Home
        </Link>
        <Link
          to="/programs"
          className="nav-link nav-item"
          onClick={handleLinkClick}
        >
          Programs
        </Link>
        <Link
          to="/careers"
          className="nav-link nav-item"
          onClick={handleLinkClick}
        >
          Careers
        </Link>

        <Link
          to="/contact-us"
          className="nav-link nav-item"
          onClick={handleLinkClick}
        >
          Contact
        </Link>
        <Link
          to="/about-us"
          className="nav-link nav-item"
          onClick={handleLinkClick}
        >
          About Us
        </Link>
        <button
          className="get-started-btn"
          onClick={() => {
            handleLinkClick();
            navigate("/register");
          }}
        >
          Get Register
        </button>
      </nav>
    </>
  );
}
